module.exports = __webpack_public_path__ + "static/prototype-4a42279f2941c5ba7a28615786c952d2.svg";